export const solution = {
    commercialRealEstateSolutions: '商业地产解决方案',
    commercialRealEstateFirstTip:
        '面向<span class="color-text">商场/写字楼/商业综合体/商业连锁</span>',
    commercialRealEstateSecondTip:
        '等商业经营性地产项目，云服务助力企业降本增效',
    consultNow: '立即咨询',
    downloadMaterials: '下载资料',
    industryPainPoints: '行业痛点',
    industryPainPointsFirstTitle: '沟通效率低',
    industryPainPointsFirstText: '群聊多、信息繁杂无组织',
    industryPainPointsSecondTitle: '多方协作难',
    industryPainPointsSecondText: '图纸问题难标注、解决进展难掌握',
    industryPainPointsThirdTitle: '数据维护难',
    industryPainPointsThirdText: '记录难查找、文件易过期',
    bringAbout: '我们能为您带来什么',
    bringAboutFirstTitle: '数字化体验',
    bringAboutFirstText: '项目信息科学组织<br/>告别群聊+Excel的杂乱无章',
    bringAboutSecondTitle: '高效协作',
    bringAboutSecondText: '问题精准定位<br/>多角色+终端的协作场景全面覆盖',
    bringAboutThirdTitle: '数字资产管理',
    bringAboutThirdText: '项目信息全生命周期存储<br/>图纸沟通过程全面可追溯',
    totalSolutionFirstTitle:
        '串联招商、工程、物业<br/>等部门图纸审核全流程覆盖',
    totalSolutionFirstText:
        '·图纸从上传 - 审核 - 存档一站式完成<br/>·图纸管理工具助力高效协作<br/>·全流程无纸化办公',
    totalSolutionSecondTitle: '多人在线沟通协作，解决<br/>异地办公困扰',
    totalSolutionSecondText:
        '·一方上传资料，项目成员实时共享<br/>·专人专项负责，不会打扰无关人员<br/>·问题进展实时同步 打破信息孤岛',
    totalSolutionThirdTitle: '施工进度计划协作、工期<br/>工序一目了然',
    totalSolutionThirdText:
        '·施工验收记录有迹可循，适时把控落地效果<br/>·开/完工前自动实时通知，避免延期<br/>·工期变更需签名，方便追溯避免扯皮',
    totalSolutionFourthTitle: '企业数字资产安全<br/>不受侵犯',
    totalSolutionFourthText:
        '·全链路数据加密传输与存储<br/>·大客户提供个性化定制服务',
    pricingScheme: '价格方案',
    aboutCase: '相关案例',
    standard: '标准版',
    autobiography: '个性化定制',
    moneyMonth:
        '<span class="unit">￥</span><span class="money">{money}</span>/月',
    standardFirstTitle: '设计与施工阶段',
    standardFirstText: '·在线协作席位数 40<br/>·项目存储空间 40G',
    standardSecondTitle: '数字资产管理阶段',
    standardSecondText: '·在线协作席位数 4<br/>·访客查看项目资料 ￥9.9/人',
    autobiographyText:
        '若您需求可达 <span class="num-box"><span class="num">{monthNum}</span><span class="bold-text">项目</span>/月</span> & <span class="num-box"><span class="num">{yearNum}</span><span class="bold-text">项目</span>/年</span>',
    autobiographySecondText:
        '我们可为您提供个性化服务，深度满足业务场景中的数字化需求。',
    contactManager: '联系专属客户经理',
    marketingDesignIntegrationSolution: '营销设计一体化解决方案',
    headerTip:
        '桌面端赋能专业设计师，大屏高效设计；移动端赋能店长&导购、渠道销售，降低获客成本',
    experienceImmediately: '立即体验',
    consultationNow: '立即咨询',
    mobileTitle: '降低创作门槛，用客户的户型去谈单',
    mobileTitleTip: '提高客户科技感互动体验，轻松留资促转化',
    mobileVideoTip: '适用于平板或折叠手机',
    pcTitle: '聚焦家装，大屏极简操作，更易上手',
    pcTitleTip: '设计文件可本地存储，提高复用率',
    pcVideoTip: '适用于桌面端',
    digitalModelSecondTitle: '共享优质设计方案，快速组建企业专属方案库',
    digitalModelSecondMainTitle: '共享优质设计方案',
    digitalModelSecondSubTitle: '快速组建企业专属方案库',
    mobileUse: '移动端适用于平板或折叠手机',
    downloadMobileApp: '下载移动端',
    downloadDesktop: '下载桌面端',
    ceilingTitle: '装配式吊顶解决方案',
    ceilingTip: '一种天花造型，无惧顶面变化，都能灵活适配',
};
